import { render, staticRenderFns } from "./PromotionItemList.vue?vue&type=template&id=3080e2d6&lang=pug&"
import script from "./PromotionItemList.vue?vue&type=script&lang=js&"
export * from "./PromotionItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports